<template>
  <div>
    <div class="pageBox">
      <div class="orderDetailPage">
        <div class="backButton" @click="goback"><i class="el-icon-back"></i></div>

        <div class="orderTitle">退款详情</div>

        <div class="orderhead">
          <div class="left">
            <span>订单号：{{ selectOrderDetailGetter.orderCode }}</span>
            <div class="line"></div>
            <span class="point" v-clipboard:copy="selectOrderDetailGetter.orderCode" v-clipboard:success="onCopy" v-clipboard:error="onError"
              >复制</span
            >
          </div>

          <div class="right btns">
            <div class="orderBtn" @click="callShop">联系客服</div>
            <!-- 待审核状态可以撤销退款申请        
              auditStatus
              
              case 1:
              this.title = '已取消'
              break
            case 2:
              this.title = '待审核'
              break
            case 3:
              this.title = '已驳回'
              break
            case 4:
              this.title = '已退款'
              break
            case 5:
              this.title = '缺货退款'  -->
            <div
              class="orderBtn"
              v-if="
                selectOrderDetailGetter?.auditStatus == '2' ||
                selectOrderDetailGetter?.orderDetail?.auditStatus == '2' ||
                selectOrderDetailGetter?.orderDetail?.commodityBackMongo?.auditStatus == '2'
              "
              @click.stop="cancelRefund"
            >
              撤销申请
            </div>
          </div>
        </div>

        <div class="gapLine"></div>

        <!-- 已取消 进度状态展示 -->
        <div
          class="orderType"
          v-if="
            selectOrderDetailGetter?.auditStatus == '1' ||
            selectOrderDetailGetter?.orderDetail?.auditStatus == '1' ||
            selectOrderDetailGetter?.orderDetail?.commodityBackMongo?.auditStatus == '1'
          "
        >
          <div class="typeName">
            <span>已取消</span>
          </div>

          <div class="progressBarBox">
            <el-progress
              class="barbase"
              :text-inside="true"
              :stroke-width="20"
              :percentage="60"
              :format="
                () => {
                  return ''
                }
              "
            ></el-progress>
            <div class="barAbs">
              <div class="bartext whiteText">下单时间</div>
              <div class="bartext whiteText">支付时间</div>
              <div class="bartext whiteText">申请时间</div>
              <div class="bartext">审核时间</div>
              <div class="bartext">退款完成</div>
            </div>
            <div class="barTimeL">
              <div class="barTime">{{ selectOrderDetailGetter.createdTime | dateFormateDayTime }}</div>
              <div class="barTime">{{ selectOrderDetailGetter.payTime | dateFormateDayTime }}</div>
              <div class="barTime">
                {{ selectOrderDetailGetter.orderDetail.applyTime || selectOrderDetailGetter.orderDetail.createTime | dateFormateDayTime }}
              </div>
              <div class="barTime"></div>
              <div class="barTime"></div>
            </div>
          </div>
        </div>
        <!-- 待审核 进度状态展示 -->
        <div
          class="orderType"
          v-if="
            selectOrderDetailGetter?.auditStatus == '2' ||
            selectOrderDetailGetter?.orderDetail?.auditStatus == '2' ||
            selectOrderDetailGetter?.orderDetail?.commodityBackMongo?.auditStatus == '2' ||
            selectOrderDetailGetter?.orderDetail?.returnStatus == '0'
          "
        >
          <div class="typeName">
            <span>待审核</span>
          </div>

          <div class="progressBarBox">
            <el-progress
              class="barbase"
              :text-inside="true"
              :stroke-width="20"
              :percentage="60"
              :format="
                () => {
                  return ''
                }
              "
            ></el-progress>
            <div class="barAbs">
              <div class="bartext whiteText">下单时间</div>
              <div class="bartext whiteText">支付时间</div>
              <div class="bartext whiteText">申请时间</div>
              <div class="bartext">审核时间</div>
              <div class="bartext">退款完成</div>
            </div>
            <div class="barTimeL">
              <div class="barTime">{{ selectOrderDetailGetter.createdTime | dateFormateDayTime }}</div>
              <div class="barTime">{{ selectOrderDetailGetter.payTime | dateFormateDayTime }}</div>
              <div class="barTime">
                {{ selectOrderDetailGetter.orderDetail.applyTime || selectOrderDetailGetter.orderDetail.createTime | dateFormateDayTime }}
              </div>
              <div class="barTime"></div>
              <div class="barTime"></div>
            </div>
          </div>
        </div>
        <!-- 已通过 进度状态展示 -->
        <div
          class="orderType"
          v-if="
            selectOrderDetailGetter?.auditStatus == '4' ||
            selectOrderDetailGetter?.orderDetail?.auditStatus == '4' ||
            selectOrderDetailGetter?.orderDetail?.commodityBackMongo?.auditStatus == '4' ||
            selectOrderDetailGetter?.orderDetail?.orderStatus == '6' // 订单的已退款
          "
        >
          <div class="typeName">
            <span>已退款</span>
          </div>

          <div class="progressBarBox">
            <el-progress
              class="barbase"
              :text-inside="true"
              :stroke-width="20"
              :percentage="100"
              :format="
                () => {
                  return ''
                }
              "
            ></el-progress>
            <div class="barAbs">
              <div class="bartext whiteText">下单时间</div>
              <div class="bartext whiteText">支付时间</div>
              <div class="bartext whiteText">申请时间</div>
              <div class="bartext whiteText">审核时间</div>
              <div class="bartext whiteText">退款完成</div>
            </div>
            <div class="barTimeL">
              <div class="barTime">{{ selectOrderDetailGetter.createdTime | dateFormateDayTime }}</div>
              <div class="barTime">{{ selectOrderDetailGetter.payTime | dateFormateDayTime }}</div>
              <div class="barTime">
                {{ selectOrderDetailGetter.orderDetail.applyTime || selectOrderDetailGetter.orderDetail.createTime | dateFormateDayTime }}
              </div>
              <div class="barTime">{{ selectOrderDetailGetter.orderDetail?.auditTime | dateFormateDayTime }}</div>
              <div class="barTime">{{ selectOrderDetailGetter.orderDetail?.auditTime | dateFormateDayTime }}</div>
            </div>
          </div>
        </div>
        <!-- 已驳回 进度状态展示 -->
        <div
          class="orderType"
          v-if="
            selectOrderDetailGetter?.auditStatus == '3' ||
            selectOrderDetailGetter?.orderDetail?.auditStatus == '3' ||
            selectOrderDetailGetter?.orderDetail?.commodityBackMongo?.auditStatus == '3'
          "
        >
          <div class="typeName">
            <span>已驳回</span>
          </div>

          <div class="progressBarBox">
            <el-progress
              class="barbase"
              :text-inside="true"
              :stroke-width="20"
              :percentage="80"
              :format="
                () => {
                  return ''
                }
              "
            ></el-progress>
            <div class="barAbs">
              <div class="bartext whiteText">下单时间</div>
              <div class="bartext whiteText">支付时间</div>
              <div class="bartext whiteText">申请时间</div>
              <div class="bartext whiteText">审核时间</div>
              <div class="bartext">退款完成</div>
            </div>
            <div class="barTimeL">
              <div class="barTime">{{ selectOrderDetailGetter.createdTime | dateFormateDayTime }}</div>
              <div class="barTime">{{ selectOrderDetailGetter.payTime | dateFormateDayTime }}</div>
              <div class="barTime">
                {{ selectOrderDetailGetter.orderDetail.applyTime || selectOrderDetailGetter.orderDetail.createTime | dateFormateDayTime }}
              </div>
              <div class="barTime">{{ selectOrderDetailGetter.orderDetail?.auditTime | dateFormateDayTime }}</div>
              <div class="barTime"></div>
            </div>
          </div>
        </div>
        <!-- 缺货退款 进度状态展示 -->
        <div
          class="orderType"
          v-if="
            selectOrderDetailGetter?.auditStatus == '5' ||
            selectOrderDetailGetter?.orderDetail?.auditStatus == '5' ||
            selectOrderDetailGetter?.orderDetail?.commodityBackMongo?.auditStatus == '5' ||
            selectOrderDetailGetter?.orderDetail?.orderStatus == '8' // 订单的缺货退款
          "
        >
          <div class="typeName">
            <span>缺货退款</span>
          </div>

          <div class="progressBarBox">
            <el-progress
              class="barbase"
              :text-inside="true"
              :stroke-width="20"
              :percentage="100"
              :format="
                () => {
                  return ''
                }
              "
            ></el-progress>
            <div class="barAbs">
              <div class="bartext whiteText">下单时间</div>
              <div class="bartext whiteText">支付时间</div>
              <div class="bartext whiteText">退款完成</div>
            </div>
            <div class="barTimeL">
              <div class="barTime">{{ selectOrderDetailGetter.createdTime | dateFormateDayTime }}</div>
              <div class="barTime">{{ selectOrderDetailGetter.payTime | dateFormateDayTime }}</div>
              <div class="barTime">{{ selectOrderDetailGetter.orderDetail?.refundTime | dateFormateDayTime }}</div>
            </div>
          </div>
        </div>

        <div class="shopMsg">
          <div class="tab">
            <img v-if="selectOrderDetailGetter?.orderDetail?.storeType === 'U'" class="tabIcon" src="@/assets/images/pt/yxdp.png" />
            <img v-if="selectOrderDetailGetter?.orderDetail?.storeType === 'S'" class="tabIcon" src="@/assets/images/pt/zy.png" />
          </div>
          <div class="title">{{ selectOrderDetailGetter?.orderDetail?.storeName }}</div>
        </div>
        <div class="itemContent">
          <el-row>
            <!-- 订单信息 -->
            <el-col :span="12">
              <div class="itemContentBox">
                <img class="goodsImg" :src="selectOrderDetailGetter.orderDetail.commodityImg" />
                <div class="rCon">
                  <div class="title">{{ selectOrderDetailGetter.orderDetail.commodityName }}</div>
                  <div class="sku">{{ selectOrderDetailGetter.orderDetail.skuInfo.replace(/\|/g, ' ') }}</div>
                  <div class="activeC">
                    <div
                      class="activeMsg"
                      v-if="
                        selectOrderDetailGetter.orderType === '1' ||
                        selectOrderDetailGetter.orderType === '2' ||
                        selectOrderDetailGetter.orderType === '3'
                      "
                    >
                      <div class="activeType">{{ selectOrderDetailGetter.orderType | getGroupName }}</div>
                      <div class="activeNum">{{ selectOrderDetailGetter.groupPeopleText }}人团</div>
                    </div>
                    <div
                      class="lessNum"
                      v-if="
                        (selectOrderDetailGetter.orderType === '1' ||
                          selectOrderDetailGetter.orderType === '2' ||
                          selectOrderDetailGetter.orderType === '3') &&
                          selectOrderDetailGetter.currentMembers && selectOrderDetailGetter.groupPeople && selectOrderDetailGetter.groupPeople - selectOrderDetailGetter.currentMembers > 0
                      "
                    >
                      已拼成{{ selectOrderDetailGetter.currentMembers }}人差{{
                        selectOrderDetailGetter.groupPeople - selectOrderDetailGetter.currentMembers
                      }}人拼成
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="textContent">
                <span v-if="selectOrderDetailGetter.orderDetail.payMethod === '1'"
                  >¥{{ formatMoney(selectOrderDetailGetter.orderDetail.price) }}</span
                >
                <span v-else>{{ formatMoney(selectOrderDetailGetter.orderDetail.price) }}提货值</span>
                <span> X {{ selectOrderDetailGetter.orderDetail.quantity }}</span>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="gapLine"></div>

        <!-- 收货地址 -->
        <div class="orderMsg">
          <div class="left">
            <div class="title">收货信息</div>
            <div class="msgline">
              <div class="msglinel">姓名:</div>
              <div class="msgliner">{{ orderAddress.name }}</div>
            </div>
            <div class="msgline">
              <div class="msglinel">联系电话:</div>
              <div class="msgliner">{{ orderAddress.tel }}</div>
            </div>
            <div class="msgline">
              <div class="msglinel">收货地址:</div>
              <div class="msgliner">{{ orderAddress.address }}</div>
            </div>
          </div>
          <!-- 修改地址 只有待付款状态可修改 -->
          <el-dropdown class="changeAddress" @command="handleCommand" v-if="!isShowNoData && selectOrderDetailGetter.orderDetail.orderStatus == '0'">
            <span class="el-dropdown-link"> 修改地址<i class="el-icon-arrow-down"></i> </span>
            <el-dropdown-menu slot="dropdown">
              <div class="addressTitle">常用地址</div>
              <el-dropdown-item :command="index" v-for="(item, index) in addressList" :key="index">
                <div class="addressItem">
                  <div class="line-1">
                    <div class="name">{{ item.name }}</div>
                    <div class="phone">{{ item.tel }}</div>
                    <div class="type" v-if="item.isDefault">默认</div>
                  </div>
                  <div class="addressDetail">{{ item.addressName }}</div>
                </div>
              </el-dropdown-item>
              <!-- <el-dropdown-item command="d" disabled>双皮奶</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
          <!-- 没有地址,去添加 -->
          <div v-if="isShowNoData && selectOrderDetailGetter.orderDetail.orderStatus == '0'" class="changeAddress" @click="goPath('/information')">
            添加地址
          </div>
        </div>

        <!-- 支付方式 显示 -->
        <div class="gapLine"></div>

        <div class="orderMsg">
          <div class="left">
            <div class="title">支付方式</div>
            <div class="msgline">
              <div class="msglinel">支付方式:</div>
              <div class="msgliner">{{ selectOrderDetailGetter.orderDetail.payMethod === '1' ? '余额' : '提货值' }}</div>
            </div>
          </div>
        </div>

        <!-- 退款原因 只有缺货退款不显示 -->
        <div
          class="gapLine"
          v-if="
            selectOrderDetailGetter?.auditStatus != '5' &&
            selectOrderDetailGetter?.orderDetail?.auditStatus != '5' &&
            selectOrderDetailGetter?.orderDetail?.commodityBackMongo?.auditStatus != '5'
          "
        ></div>

        <div
          class="orderMsg"
          v-if="
            selectOrderDetailGetter?.auditStatus != '5' &&
            selectOrderDetailGetter?.orderDetail?.auditStatus != '5' &&
            selectOrderDetailGetter?.orderDetail?.commodityBackMongo?.auditStatus != '5'
          "
        >
          <div class="left">
            <div class="title">退款原因</div>
            <div class="msgline">
              <div class="msglinel">退款原因:</div>
              <div class="msgliner">
                {{ selectOrderDetailGetter?.orderDetail?.notes || selectOrderDetailGetter?.orderDetail?.commodityBackMongo?.notes || '--' }}
              </div>
            </div>
          </div>
        </div>
        <!-- 驳回原因 已驳回显示 -->
        <div
          class="gapLine"
          v-if="
            selectOrderDetailGetter?.auditStatus == '3' ||
            selectOrderDetailGetter?.orderDetail?.auditStatus == '3' ||
            selectOrderDetailGetter?.orderDetail?.commodityBackMongo?.auditStatus == '3'
          "
        ></div>

        <div
          class="orderMsg"
          v-if="
            selectOrderDetailGetter?.auditStatus == '3' ||
            selectOrderDetailGetter?.orderDetail?.auditStatus == '3' ||
            selectOrderDetailGetter?.orderDetail?.commodityBackMongo?.auditStatus == '3'
          "
        >
          <div class="left">
            <div class="title">驳回原因</div>
            <div class="msgline">
              <div class="msglinel">驳回原因:</div>
              <div class="msgliner" style="color: #eb6643">{{ selectOrderDetailGetter?.orderDetail?.rejectAnswer || '--' }}</div>
            </div>
          </div>
        </div>
        <!-- 买家留言 -->
        <div class="gapLine" v-if="selectOrderDetailGetter.orderDetail.message"></div>

        <div class="orderMsg" v-if="selectOrderDetailGetter.orderDetail.message">
          <div class="left">
            <div class="title">买家留言</div>
            <div class="msgline">
              <div class="msglinel">买家留言:</div>
              <div class="msgliner">{{ selectOrderDetailGetter.orderDetail.message || '--' }}</div>
            </div>
          </div>
        </div>

        <div class="gapLine"></div>

        <div class="orderprice">
          <div class="allgoodsPrice">
            <div class="left">商品总价:</div>
            <div class="right">
              <span v-if="selectOrderDetailGetter.orderDetail.payMethod === '1'"
                >¥{{
                  formatMoney(calculateOrderTotal(selectOrderDetailGetter.orderDetail.price, selectOrderDetailGetter.orderDetail.quantity))
                }}</span
              >
              <span v-else
                >{{
                  formatMoney(calculateOrderTotal(selectOrderDetailGetter.orderDetail.price, selectOrderDetailGetter.orderDetail.quantity))
                }}提货值</span
              >
            </div>
          </div>
          <div class="yfPrice" v-if="Number(shippingFee) > 0">
            <div class="left">运费:</div>
            <div class="right">￥{{ formatMoney(shippingFee || 0) }}</div>
          </div>
          <div class="allPrice">
            <div class="left">退款金额:</div>
            <div class="right">
              <span class="value" v-if="selectOrderDetailGetter.orderDetail.payMethod === '1'"
                >¥
                {{
                  formatMoney(
                    calculateOrderTotal(selectOrderDetailGetter.orderDetail.price, selectOrderDetailGetter.orderDetail.quantity, shippingFee)
                  )
                }}</span
              >
              <span class="value" v-else>
                {{ formatMoney(calculateOrderTotal(selectOrderDetailGetter.orderDetail.price, selectOrderDetailGetter.orderDetail.quantity)) }}
                提货值
                <span v-if="formatMoney(shippingFee) > 0"> + ¥ {{ formatMoney(shippingFee || 0) }} </span>
              </span>
            </div>
          </div>
        </div>

        <!-- 联系客服 -->
        <el-dialog class="refundDialog" title="" :visible.sync="showConct" :close-on-click-modal="false" width="410px">
          <div class="logistics">
            <div class="title">联系客服</div>
            <div class="desInfo">
              <span class="name">客服电话:</span>
              <span class="price">{{ selectOrderDetailGetter.orderDetail.storeCellphone }}</span>
            </div>
            <div class="actionWrap">
              <span class="btns" @click="showConct = false">取消</span>
              <span class="savebtn" @click="callPhone()">确定</span>
            </div>
          </div>
        </el-dialog>
        <!-- 取消退款申请 -->
        <el-dialog class="refundDialog" title="" :visible.sync="showCancel" :close-on-click-modal="false" width="410px">
          <div class="logistics">
            <div class="title">确定取消退款申请</div>
            <div class="actionWrap">
              <span class="btns" @click="showCancel = false">取消</span>
              <span class="savebtn" @click="cancelRefundOrder()">确定</span>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
    <Cellphone :phone="cellStore" ref="cellphoneRef" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import VueQr from 'vue-qr'
import Cellphone from '@/views/equityMall/pt/components/cellStore.vue'
export default {
  filters: {
    getGroupName(val) {
      switch (val) {
        case '1':
          return '普通拼团'
        case '2':
          return '阶梯拼团'
        case '3':
          return '超级拼团'
        case 'M':
          return '限时秒杀'
        default:
          return ''
      }
    },
    // 订单状态
    statusFormat(id) {
      let statusName = null
      switch (id) {
        case 0:
          statusName = '待付款'
          break
        case 1:
          statusName = '待发货'
          break
        case 2:
          statusName = '待收货'
          break
        case 3:
          statusName = '已完成'
          break
        case 4:
          statusName = '交易关闭'
          break
        case 5:
          statusName = '退款申请中'
          break
        case 6:
          statusName = '已退款'
          break
        case 7:
          statusName = '已删除'
          break
        case 8:
          statusName = '缺货退款'
          break
        case 9:
          statusName = '更换地址申请审核'
          break
        case 10:
          statusName = '拼团中'
          break
        case 11:
          statusName = '拼团失败'
          break
        default:
          statusName = '--'
          break
      }
      return statusName
    },
    // 售后订单状态
    returnStatusFormat(id) {
      let statusName = null
      switch (id) {
        case '0':
          statusName = '待审核'
          break
        case '1':
          statusName = '已驳回'
          break
        case '2':
          statusName = '已退款'
          break
        case '3':
          statusName = '已取消'
          break
        default:
          statusName = '--'
          break
      }
      return statusName
    },
    auditStatusFormat(id) {
      let statusName = null
      switch (id) {
        case 1:
          statusName = '已取消'
          break
        case 2:
          statusName = '待审核'
          break
        case 3:
          statusName = '已驳回'
          break
        case 4:
          statusName = '已退款'
          break
        case 5:
          statusName = '缺货退款'
          break
        default:
          statusName = '--'
          break
      }
      return statusName
    }
  },
  components: {
    VueQr,
    Cellphone
  },
  data() {
    return {
      cellStore: null,
      countdownTimers: [],
      countdownText: '', // 倒计时
      isAddressLoading: true, // 地址请求中
      isShowNoData: true, // 没有地址,需要设置
      addressList: [], // 地址列表
      orderAddress: {
        id: '',
        name: '',
        tel: '',
        address: ''
      },
      shippingFee: null, // 运费
      qrUrl: '',

      showConct: false, // 联系店铺
      showCancel: false, // 取消退款申请
      isRepeat: false
    }
  },
  computed: {
    ...mapGetters(['selectOrderDetailGetter'])
  },
  mounted() {
    this.init()
    this.queryFirmAddress()
  },
  beforeDestroy() {
    this.clearAllCountdowns()
  },
  methods: {
    init() {
      // 判断订单状态
      if (this.selectOrderDetailGetter.orderDetail.orderStatus == '0' && this.selectOrderDetailGetter.paymentDeadline) {
        // 待付款 打开计时器
        this.startCountdown(this.selectOrderDetailGetter, 'paymentDeadline')
      } else if (this.selectOrderDetailGetter.orderDetail.orderStatus == '10' && this.selectOrderDetailGetter.groupDeadline) {
        // 拼团中 打开计时器
        this.startCountdown(this.selectOrderDetailGetter, 'groupDeadline')
        // 生成邀请好友二维码
        this.makeQRCode()
      }
      // 获取默认地址信息
      this.orderAddress = {
        id: this.selectOrderDetailGetter.orderDetail.addressId,
        name: this.selectOrderDetailGetter.orderDetail.receiverName,
        tel: this.selectOrderDetailGetter.orderDetail.receiverPhone,
        address: this.selectOrderDetailGetter.orderDetail.receiverAddress
      }
      // 记录默认运费
      this.shippingFee = this.selectOrderDetailGetter.orderDetail.shippingFee
    },
    goPath(path) {
      this.$router.push(path)
    },
    goback() {
      this.$router.go(-1)
    },
    // 格式化金额显示（保留两位小数）
    formatMoney(amount) {
      return Number(amount).toFixed(2)
    },
    // 计算订单合计（商品总价 + 运费）
    calculateOrderTotal(price, quantity, shippingFee) {
      const totalPrice = this.moneyMultiply(Number(price) || 0, Number(quantity) || 0)
      const shipping = Number(shippingFee) || 0
      return this.moneyAdd(totalPrice, shipping)
    },
    // 金额乘法（处理精度问题）
    moneyMultiply(num1, num2) {
      const factor = 100 // 转换为分
      const int1 = Math.round(num1 * factor)
      const result = (int1 * num2) / factor
      return Math.round(result * 100) / 100 // 保留两位小数
    },
    // 金额加法（处理精度问题）
    moneyAdd(num1, num2) {
      const factor = 100 // 转换为分
      const int1 = Math.round(num1 * factor)
      const int2 = Math.round(num2 * factor)
      return (int1 + int2) / factor
    },
    // 格式化倒计时显示
    formatCountdown(seconds) {
      if (seconds <= 0) return '00:00:00'
      const hours = Math.floor(seconds / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      const secs = seconds % 60
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
    },
    // 启动倒计时
    startCountdown(item, deadlineField = 'paymentDeadline') {
      // 如果已经有定时器，先清除
      if (this.countdownTimers[item.orderId]) {
        clearInterval(this.countdownTimers[item.orderId])
      }
      // 计算剩余秒数 - 根据传入的字段名获取截止时间
      const deadline = new Date(item[deadlineField]).getTime()
      const now = new Date().getTime()
      let remainingSeconds = Math.floor((deadline - now) / 1000)
      if (remainingSeconds <= 0) {
        this.countdownText = '00:00:00'
        return
      }
      // 设置初始倒计时文本
      // this.$set(item, 'countdownText', this.formatCountdown(remainingSeconds))
      this.countdownText = this.formatCountdown(remainingSeconds)
      // 启动定时器
      this.countdownTimers[item.orderId] = setInterval(() => {
        remainingSeconds--
        if (remainingSeconds <= 0) {
          clearInterval(this.countdownTimers[item.orderId])
          delete this.countdownTimers[item.orderId]
          this.countdownText = '00:00:00'
          // 倒计时结束，刷新数据
          // this.getOrderList()
        } else {
          this.countdownText = this.formatCountdown(remainingSeconds)
        }
      }, 1000)
    },
    // 清除所有倒计时
    clearAllCountdowns() {
      Object.keys(this.countdownTimers).forEach((orderId) => {
        clearInterval(this.countdownTimers[orderId])
      })
      this.countdownTimers = {}
    },
    onCopy(e) {
      this.$message.success('你复制了：' + e.text)
    },
    onError(e) {
      this.$message.error(e.text)
    },
    // 邀请好友二维码
    makeQRCode() {
      const baseUrl = window.g.REGISTER_URLS + '?type=ptOrderInviteFriends&shareMsg=' // 邀请好友拼团地址

      const orderId = this.selectOrderDetailGetter.orderDetail.orderId
      const currentUserId = this.sessionInfoGetter?.userId || sessionStorage.getItem('userId') || ''
      const encryptedOrderId = baseUrl + btoa(`SHARE_ORDER_${orderId}_USER_${currentUserId}`)

      this.qrUrl = encryptedOrderId
    },
    // 选地址
    handleCommand(command) {
      console.log('地址', this.addressList[command])
      this.$message.success('选中地址' + this.addressList[command].addressName + ', 正在重新计算运费')
      // 替换地址显示
      this.orderAddress = {
        id: this.addressList[command].addressId,
        name: this.addressList[command].name,
        tel: this.addressList[command].tel,
        address: this.addressList[command].addressName
      }

      this.calculateFreight()
    },
    // 计算运费
    calculateFreight() {
      protocolPt.param_calculateFreight.param.commoditySkuId = this.selectOrderDetailGetter.orderDetail.skuId
      protocolPt.param_calculateFreight.param.commodityId = this.selectOrderDetailGetter.orderDetail.commodityId
      protocolPt.param_calculateFreight.param.quantity = this.selectOrderDetailGetter.orderDetail.quantity
      protocolPt.param_calculateFreight.param.addressId = this.orderAddress.id
      http.postFrontMall(protocolPt.param_calculateFreight).then((response) => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value) {
            this.shippingFee = value.shippingFee
          }
          return true
        } else {
          this.$message.error(message)
          return false
        }
      })
    },
    // 获取收货地址
    queryFirmAddress() {
      var that = this
      that.addressList = []
      BaseApi.getUserAddress({}).then((response) => {
        const { value, message, code } = response.data
        that.isAddressLoading = false
        if (Number(code) === 0) {
          if (value.length !== 0) {
            that.isShowNoData = false
            for (const item of value) {
              item.name = item.recipients
              item.tel = item.recipientsCellphone
              item.isDefault = item.defaultFlag
              that.addressList.push(item)
            }
          } else {
            that.isShowNoData = true
          }
        } else {
          this.$message.error(message)
        }
      })
    },
    // 联系商家
    callShop() {
      // this.showConct = true
      this.cellStore = this.selectOrderDetailGetter.orderDetail.storeCellphone
      this.$refs.cellphoneRef.showDialog()
    },
    callPhone() {
      window.location.href = 'tel://' + this.selectOrderDetailGetter.orderDetail.storeCellphone
    },
    cancelRefund() {
      this.showCancel = true
    },
    // 取消退款申请
    cancelRefundOrder() {
      if (!this.isRepeat) {
        this.isRepeat = true
      } else {
        this.$message.warning('请求发送中,请稍候再试')
        return
      }
      protocolPt.param_cancelRefund.param.orderDetailId = this.selectOrderDetailGetter.orderDetail.orderDetailId
      http
        .postFrontMall(protocolPt.param_cancelRefund)
        .then((response) => {
          const { code, message } = response.data
          this.isRepeat = false
          if (Number(code) === 0) {
            this.$message.success(message)
            setTimeout(() => {
              this.$router.go(-1)
            }, 1000)
          } else {
            this.$message.error(message)
          }
        })
        .catch(() => {
          this.isRepeat = false
        })
    }
  }
}
</script>
<style scoped lang="scss">
.pageBox{
  height: calc(100vh - 40px);
  overflow-y: auto;
  overflow-x: hidden;
}
.orderDetailPage {
  width: 1200px;
  // height: 100%;
  margin: 34px auto;

  .backButton {
    cursor: pointer;
    position: fixed;
    left: 50px;
    top: 70px;
    width: 40px;
    height: 40px;
    background: #000000;
    border-radius: 2px 2px 2px 2px;
    opacity: 0.5;

    color: #fff;
    font-size: 20px;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .orderTitle {
    font-family: PingFang TC, PingFang TC;
    font-weight: 500;
    font-size: 20px;
    color: #333333;
  }

  .orderhead {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 0;
    .left {
      display: flex;
      align-items: center;
      gap: 6px;
      span {
        font-family: PingFang TC, PingFang TC;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
      }
      .line {
        width: 1px;
        height: 12px;
        background: #000000;
        opacity: 0.1;
      }
      .point {
        cursor: pointer;
      }
    }
    .right {
      display: flex;
      align-items: center;
      gap: 10px;
      .orderBtn {
        width: 90px;
        height: 28px;
        background: #f4f4f4;
        border-radius: 2px 2px 2px 2px;
        font-family: PingFang TC, PingFang TC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;

        display: flex;
        justify-content: center;
        align-items: center;

        cursor: pointer;
      }
      .activeBtn {
        background: #1571db;
        color: #ffffff;
      }
    }
  }

  .gapLine {
    margin: 20px 0;
    background: #000000;
    opacity: 0.1;
    height: 1px;
  }

  .orderType {
    margin: 20px 0;

    position: relative;
    .typeName {
      display: flex;
      align-items: center;
      margin: 20px 0;
      height: 22px;
      span {
        font-family: PingFang TC, PingFang TC;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
      }
      .orange {
        color: #eb6643;
      }
    }
    .progressBarBox {
      position: relative;
      .barbase {
        position: relative;
        z-index: 1;
      }
      .barAbs {
        position: absolute;
        z-index: 2;
        display: flex;
        align-items: center;
        top: 0;
        height: 20px;
        left: 0;
        right: 0;
        .bartext {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: PingFang TC, PingFang TC;
          font-weight: 400;
          font-size: 12px;
          color: #333333;
        }
        .whiteText {
          color: #fff;
        }
      }
      .barTimeL {
        margin: 16px 0 18px;
        display: flex;
        align-items: center;
        .barTime {
          flex: 1;
          font-family: PingFang TC, PingFang TC;
          font-weight: 400;
          font-size: 14px;
          color: #666666;

          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .shopMsg {
    margin: 18px 0 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    .tab {
      display: flex;
      align-items: center;
      .tabIcon {
        height: 16px;
      }
    }
    .title {
      font-family: PingFang TC, PingFang TC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
    }
  }

  .itemContent {
    .itemContentBox {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 10px;
      width: 100%;
      flex-grow: 0;
      flex-shrink: 0;
      .goodsImg {
        flex-grow: 0;
        flex-shrink: 0;
        width: 62px;
        height: 62px;
        background: #d9d9d9;
        border-radius: 2px 2px 2px 2px;
        margin-left: 10px;
      }
      .rCon {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 62px;

        .title {
          font-family: PingFang TC, PingFang TC;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 340px;
        }
        .sku {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #999999;
          line-height: 19px;
        }
        .activeC {
          display: flex;
          align-items: center;
          gap: 8px;
          height: 20px;
          min-width: 10px;
          .activeMsg {
            display: flex;
            align-items: center;
            height: 18px;
            background: #ffffff;
            border-radius: 2px 2px 2px 2px;
            border: 1px solid rgba(235, 102, 67, 0.7);
            .activeType {
              display: flex;
              justify-content: center;
              align-items: center;
              background: #ffe3de;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #eb6643;
              line-height: 16px;
              padding: 0 4px;
            }
            .activeNum {
              display: flex;
              justify-content: center;
              align-items: center;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #eb6643;
              line-height: 16px;
              padding: 0 8px;
            }
          }
          .lessNum {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #eb6643;
            line-height: 19px;
          }
        }
      }
    }
    .textContent,
    .textContent span {
      font-family: PingFang TC, PingFang TC;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      text-align: left;
    }
  }

  .orderMsg {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      font-family: PingFang TC, PingFang TC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
    }
    .msgline {
      margin: 10px 0;
      display: flex;
      align-items: center;
      .msglinel {
        width: 84px;
        display: flex;
        align-items: center;
        font-family: PingFang TC, PingFang TC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
      }
      .long {
        flex: 1;
        height: 80px;
        align-items: flex-start;
        width: 230px;
      }
      .msgliner {
        font-family: PingFang TC, PingFang TC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;

        display: flex;
        align-items: center;
        gap: 6px;
        span {
          font-family: PingFang TC, PingFang TC;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
        }
        .line {
          width: 1px;
          height: 12px;
          background: #000000;
          opacity: 0.1;
        }
        .point {
          cursor: pointer;
        }
      }
    }

    .changeAddress {
      width: 100px;
      height: 28px;
      background: #f4f4f4;
      border-radius: 2px 2px 2px 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: PingFang TC, PingFang TC;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
    }
  }

  .orderprice {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .allgoodsPrice,
    .yfPrice,
    .allPrice {
      display: flex;
      align-items: center;
      .left {
        font-family: PingFang TC, PingFang TC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        text-align: right;
      }
      .right {
        font-family: PingFang TC, PingFang TC;
        font-weight: 400;
        font-size: 14px;
        color: #eb6643;
        text-align: right;
        min-width: 150px;
      }
    }
    .allgoodsPrice,
    .yfPrice {
      margin-bottom: 10px;
    }
    .allPrice {
      margin-top: 10px;
      .right {
        font-weight: 500;
        font-size: 18px;
        color: #eb6643;
      }
    }
  }
}
.addressTitle {
  padding: 10px 20px 8px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  line-height: 24px;
}

.el-dropdown-menu {
  background-color: #fff !important;
  border: 1px solid #ebeef5 !important;
  color: rgba(0, 0, 0, 0.6) !important;
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background: rgba(#1571db, 0.05) !important;
}
.el-dropdown-menu__item {
  color: rgba(0, 0, 0, 0.6) !important;
  .addressItem {
    display: flex;
    flex-direction: column;
    padding: 10px 0 5px;
    .line-1 {
      display: flex;
      align-items: center;
      gap: 10px;
      .name,
      .phone {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 24px;
      }
      .type {
        width: 38px;
        height: 18px;
        background: #f4f4f4;
        border-radius: 5px 5px 5px 5px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .addressDetail {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
    }
  }
}
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #66b1ff !important;
}
.el-dropdown-menu__item.is-disabled {
  color: rgba(#999999, 0.5) !important;
}

.refundDialog {
  /deep/.el-dialog {
    background: #ffffff !important;
    // border-radius: 8px 8px 8px 8px;
  }
  /deep/.el-dialog__header {
    display: none;
  }
  /deep/.el-dialog__body {
    padding: 20px 30px 40px;
    position: relative;
    box-sizing: border-box;
  }
  .title {
    // font-size: 24px;
    // font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
    // font-weight: bold;
    // color: #333333;
    // text-align: center;
    font-size: 16px;
    font-family: PingFang TC-Regular;
    color: #333333;
    text-align: center;
  }
  .desInfo {
    margin-top: 20px;
    height: 45px;
    background: #f4f4f4;
    border-radius: 4px 4px 4px 4px;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .name {
      font-size: 14px;
      font-family: PingFang TC-Regular;
      font-weight: normal;
      color: #333333;
    }
    .price {
      font-size: 14px;
      font-family: PingFang TC-Regular;
      font-weight: normal;
      color: #333333;
    }
  }
  .inputWrap {
    margin-top: 20px;
    .name {
      margin-bottom: 10px;
      font-size: 16px;
      font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
      font-weight: 400;
      color: #c5c5c5;
      line-height: 19px;
    }
    /deep/.el-textarea__inner {
      height: 100px;
      background: #f4f4f4;
      border-radius: 4px 4px 4px 4px;
      border: none;
      padding: 10px 20px;
      font-size: 16px;
      font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
      font-weight: bold;
      color: #333333;
    }
    /deep/.el-textarea .el-input__count {
      background: #f4f4f4;
    }
  }
  .actionWrap{
		margin-top: 33px;
		display: flex;
		justify-content: center;
		.btns{
			display: inline-block;
			width: 156px;
			height: 40px;
			border-radius: 40px;
			font-size: 20px;
			font-family: PingFang TC-Regular;
			line-height: 40px;
			text-align: center;
			cursor: pointer;
			background: #F4F4F4;
			color: #999999;
		}
		.savebtn{
			margin-left: 20px;
			width: 156px;
			display: inline-block;
			border-radius: 40px;
			height: 40px;
			font-size: 20px;
			font-family: PingFang TC-Regular;
			text-align: center;
			line-height: 40px;
			cursor: pointer;
			color: #FFFFFF;
			background: linear-gradient(to right, #EA553C, #EE8C54);
		}
	}
}
</style>
